"use strict";

var LoggerInstance = require("js-logger").get("PayPalHelper");

var CheckoutActions = require("./CheckoutActions");

var Spinner = require("../client/Spinner");

var WizardConstants = require("../constants/WizardConstants");

var CheckoutHelper = require("../commonComponents/CheckoutHelper");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

module.exports = {
	getBaseUrl: function () {
		return window.location.protocol + // http(s)
			"//" +
			window.location.hostname + // host may contain port, so play it safe and only return hostname
			(window.location.port ? ":" + window.location.port : "") // if there's a port, tack it on.
	},

	getCreateUrl: function() {
		return `${this.getBaseUrl()}/api/paypal/payment/create`;
	},

	getPayPalButtonOptions: function(isPayPalLive, company, enabledOnLoad) {
		return {
			env: (isPayPalLive ? "production" : "sandbox"),
			style: {
				tagline: false,
				label: "paypal"
			},
			commit: true,
			validate: function (actions) {
				CheckoutActions.setPayPalActions(actions, enabledOnLoad);
			},
			onClick: function () {
				Spinner.showSpinner();
				CheckoutActions.updatePayPalButtonState(/*shouldMarkInvalidComponents*/ true).fail(() => {
					if (!CheckoutActions.isPayPalEnabled()) {
						//There were shopping cart errors when the page loaded
						var shoppingCartErrors = CheckoutActions.getShoppingCartErrors();
						if (CheckoutActions.getDoShoppingCartErrorToPreventCheckoutExist() && shoppingCartErrors.length) {
							BootstrapPrompt.alert(shoppingCartErrors.join("<br>"));
							return;
						}

						var additionalErrorMessage = CheckoutActions.getPayPalErrorMessages();

						var errorMessage = "";
						if (additionalErrorMessage) {
							additionalErrorMessage.forEach(message => {
								errorMessage += errorMessage !== "" ? "\n" : "";
								errorMessage += message;
							});

							if (errorMessage) {
								errorMessage = `\n${errorMessage}`;
							}
						}

						BootstrapPrompt.alert(
							CheckoutActions.getWizardValue(
								WizardConstants.WIZARDS.PAYPAL_MESSAGES,
								WizardConstants.PAYPAL_MESSAGE_FIELDS.ADDITIONAL_INFORMATION_REQUIRED
							) + errorMessage
						);
					}
				}).always(() => {
					Spinner.removeSpinner();
				});
			},
			payment: (data, actions) => {
				// Deferred object to return while we wait for payment processing.
				var paymentCreateResult = $.Deferred();

				var preCheckOutResult = CheckoutActions.processPayPalPaymentPreCheckout();
				preCheckOutResult.done((data) => {
					var requestData = {
						company,
						transactionData: JSON.stringify(data)
					};

					actions.request.post(this.getCreateUrl(), requestData)
						.then((res) => {
							paymentCreateResult.resolve(res.paymentId);
						});
				});

				return paymentCreateResult;
			},
			onAuthorize: (data) => {
				var paymentExecuteDeferred = $.Deferred();

				// We don't validate prior to checking out with PayPal here because it has already
				// been done in the onClick function's call to CheckoutActions.updatePayPalButtonState();

				CheckoutHelper.getCheckoutData().always(dataToSend => {
					if (!dataToSend) {
						paymentExecuteDeferred.reject();
						Spinner.removeSpinner();
						return;
					}

					/*
					* We're using existing fields in the PaymentContainer/CombinedPaymentDto instead of defining
					* new fields specifically for PayPal REST API payments.
					* 
					* hostedPageToken: The ID (paymentID) used by PayPal to identify the created payment.
					* cardName: The ID (payerID) used by PayPal to identify the account making the payment.
					* type: The DDCPAYTYPE for PayPal payments
					*/
					var payPalPaymentInformation = {
						hostedPageToken: data.paymentID,
						cardName: data.payerID,
						type: "PAYPAL"
					};

					CheckoutActions.processPreTokenizedPaymentCheckout(payPalPaymentInformation, dataToSend);

					paymentExecuteDeferred.resolve();
				});

				return paymentExecuteDeferred;
			},
			onCancel: (data, actions) => {
				Spinner.removeSpinner();
				BootstrapPrompt.alert(
					CheckoutActions.getWizardValue(
						WizardConstants.WIZARDS.PAYPAL_MESSAGES,
						WizardConstants.PAYPAL_MESSAGE_FIELDS.CREATE_ERROR
					)
				);
			},
			onError: (error) => {
				Spinner.removeSpinner();
				BootstrapPrompt.alert(
					CheckoutActions.getWizardValue(
						WizardConstants.WIZARDS.PAYPAL_MESSAGES,
						WizardConstants.PAYPAL_MESSAGE_FIELDS.CHECKOUT_ERROR
					)
				);

				LoggerInstance.error(CheckoutActions.getWizardValue(
					WizardConstants.WIZARDS.PAYPAL_MESSAGES,
					WizardConstants.PAYPAL_MESSAGE_FIELDS.CHECKOUT_ERROR
				), error);
			}
		};
	}
};